import { FaqSectionDto } from '@/components/service-pages/Faq/types';
import { extractPlainTextFromBlocksContent } from '@/lib/blocks-content';

export const findFaqSectionInContent = (content: unknown): FaqSectionDto | undefined => {
	if (!Array.isArray(content)) return undefined;

	const block = content.find(
		(item): item is FaqSectionDto & { __component?: string } =>
			!!item &&
			typeof item === 'object' &&
			((item as { __component?: string }).__component ?? '').includes('faq-section') &&
			Array.isArray((item as FaqSectionDto).faqItems) &&
			(item as FaqSectionDto).faqItems.length > 0
	);

	return block;
};

export const buildFaqPageJsonLd = (data: FaqSectionDto) => ({
	'@context': 'https://schema.org',
	'@type': 'FAQPage',
	mainEntity: data.faqItems.map(item => ({
		'@type': 'Question',
		name: item.question,
		acceptedAnswer: {
			'@type': 'Answer',
			text: extractPlainTextFromBlocksContent(item.answer)
		}
	}))
});
